<template>
  <base-dropdown position="right" class="nav-link pr-0">
    <base-button slot="title" type="default" class="dropdown-toggle mr-0 btn-custom">
      <span v-if="$i18n.locale === 'en'">
        <img width="23" height="17" src="/static/img/icons/GB.png" alt="UK flag"> <span v-if="isLabel">EN</span>
      </span>
      <span v-if="$i18n.locale === 'jp'"><img width="23" height="17" src="/static/img/icons/JP.png" alt="JP flag"> <span v-if="isLabel">JP</span></span>
    </base-button>
    <div class="dropdown-item" @click="changeLanguage('jp')" v-if="$i18n.locale === 'en'">
      <span>
        <img class="mr-2" width="23" height="17" src="/static/img/icons/JP.png" alt="JP flag"> {{ $t('japanese') }}
      </span>
    </div>
    <div class="dropdown-item" @click="changeLanguage('en')" v-if="$i18n.locale === 'jp'">
      <span>
        <img class="mr-2" width="23" height="17" src="/static/img/icons/GB.png" alt="EN flag"> {{ $t('english') }}
      </span>
    </div>
  </base-dropdown>
</template>

<script>
export default {
  name: 'LanguageDropdown',
  props: {
    isLabel: {
      type: Boolean,
      default: true,
      description: 'Whether dropdown should be appended to document body'
    }
  },
  watch: {
    '$route.name': {
      handler () {
        if (this.$route.query && this.$route.query.lang) {
          this.changeLanguage(this.$route.query.lang)
        }
      }
    }
  },
  mounted() {
    if (this.$route.query && this.$route.query.lang) {
      this.changeLanguage(this.$route.query.lang)
    }
  },
  methods: {
    changeLanguage (lang) {
      if (window.location.search.indexOf(`lang=${lang}`) < 0) {
        this.$router.push({ query: Object.assign({...this.$route.query}, { lang: lang }) })
      }
      this.$i18n.locale = lang
    }
  }
}
</script>
<style scoped>
  .btn-custom {
    padding: 5px 10px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/LanguageDropdown.vue